import React, { useEffect, useState } from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import schoolServices from "../services/school_services";
import SchoolInfoCard from "../components/schoolInfoCard/SchoolInfoCard";
import ChangePassword from "../components/ChangePassword/ChangePassword";

const SchoolProfile = () => {
    const [profle, ProfileData] = useState()
    useEffect(() => {
        getSchoolProfile()
    }, [])

    const getSchoolProfile = () => {
        schoolServices.getSchoolProfile().then(resp => {
            ProfileData(resp.data)
        })
    }
    return (
        <div className="dashbrd_pg">
            <SchoolHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>School Profile</h2>
                        </div>
                        <div className="prfl_cntnt">
                            <Card className="pg_card">
                                <Card.Body>
                                    <Row>
                                        <Col md={7}>
                                            <SchoolInfoCard type={"edit"} />
                                        </Col>
                                        <ChangePassword />
                                    </Row>

                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default SchoolProfile;
